import { filter } from 'rxjs';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { OnInit, inject, Component, DestroyRef, ViewEncapsulation } from '@angular/core';

import { AuthService } from '@/app/core/services/auth/auth.service';
import { ErrorStateService } from '@/app/core/services/error-state.service';

import { SidebarComponent } from '@/app/shared/components/layout/sidebar/sidebar.component';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet, SidebarComponent],
})
export class DefaultLayoutComponent implements OnInit {
  protected readonly destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    protected router: Router,
    protected authService: AuthService,
    protected readonly errorStateService: ErrorStateService,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.errorStateService.clearErrorMessage();
      });
  }
}
